
import { ProductGroup } from "@/models/base/product-group";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppFileUpload from "@/components/FileUploadDropAndProgress.vue";
import { AWSFileService } from "@/services/aws-file-service";
import { v4 } from "uuid";

export default Vue.extend({
	data(){
		return {
			loading: true,
			group: new ProductGroup(),
			isUploadingImage: false
		};
	},
	props: {
		value: {
			type: Object as ()=>ProductGroup,
			required: true
		}
	},
	computed: {
		title():TranslateResult{
			return this.$ct("edit-group-properties-title", {name: this.value.Name});
		},
		allowedExtensions():string[]{
			return ["jpg","jpeg","png"];
		},
		controlsDisabled():boolean {
			return this.isUploadingImage;
		}
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		confirm(){
			this.value.ShowOnDisplay = this.group.ShowOnDisplay;
			this.value.ImageAWSFileID = this.group.ImageAWSFileID;
			this.value.ImageAWSFile = this.group.ImageAWSFile;
			this.$emit("close");
		},
		async onImageInput(file:File){
			let uuid = v4();
			this.isUploadingImage = true;
			try{
				let awsFile = await AWSFileService.uploadFile(`/product-groups/photos/${uuid}`, file);
				this.group.ImageAWSFileID = awsFile.ID;
				this.group.ImageAWSFile = awsFile;
			}catch(error){

			}
			this.isUploadingImage = false;
		},
		removeImage(){
			this.group.ImageAWSFileID = null;
			this.group.ImageAWSFile = null;
		}
	},
	async mounted(){
		this.group = new ProductGroup(this.value.getJSON());
		this.group.ImageAWSFile = this.value.ImageAWSFile;
		this.loading = false;
	},
	components: {
		AppFileUpload
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
